import React, { useEffect } from 'react';
import { Main } from '@components/Main';
import { ContentContainer } from '@components/Content';
import { withTrans } from '@i18n/withTrans';

const Content = ({ i18n, pageContext }) => {
  
  useEffect(() => {
    i18n.changeLanguage(pageContext.lang)
  }, [i18n, pageContext])
  
  return (
    <Main pageContext={pageContext}>
      <ContentContainer/>
    </Main>
  )
}

const ContentPage = withTrans(Content);

export default ContentPage 
